import { parseQuerystring } from "../../utils/querystring";

export function getSearchFromQuerystring(querystring) {
    const params = parseQuerystring(querystring);

    let searchQuery = '';

    // first we try extract the search query from params.
    if ( 'searchQuery' in params ) {
        searchQuery = params['searchQuery'][0];  // values are arrays of items.
    }

    return searchQuery
}

export function getActiveFiltersFromQuerystring(querystring) {
    const params = parseQuerystring(querystring);

    let activeFilters = [];

    // first remove any unwanted params
    if ( 'searchQuery' in params ) {
        // specifies search query which is handled elsewhere
        delete params['searchQuery']
    }
    if ( 'edit' in params ) {
        // specifies edit mode is on which is handled elsewhere
        delete params['edit']
    }
    if ( 'saved' in params ) {
        // specifies saving success which is handled elsewhere
        delete params['saved']
    }
    if ( 'sortBy' in params ) {
        // specifies sorting column which is handled elsewhere
        delete params['sortBy']
    }
    if ( 'desc' in params ) {
        // specifies sorting order which is handled elsewhere
        delete params['desc']
    }

    // remaining items (if any) are filters. Let's unpack them.
    Object.keys(params).map(paramKey => {
        params[paramKey].map(paramValue => {
            activeFilters.push({field: paramKey, value: paramValue})
        });
    });

    return activeFilters
}

export function getEditModeFromQuerystring(querystring) {
    const params = parseQuerystring(querystring);
    return 'edit' in params
}

export function getSortByFromQuerystring(querystring) {
    const params = parseQuerystring(querystring)

    let sortBy = null;

    if ( 'sortBy' in params ) {
        sortBy = params['sortBy'][0];  // values are arrays of items
    }

    return sortBy
}

export function getSortDescendingFromQuerystring(querystring) {
    const params = parseQuerystring(querystring)

    let descending = true;

    if ( 'desc' in params ) {
        descending = params['desc'][0];  // values are arrays of items
    }

    return descending
}
